import Vue from 'vue';
import optimusApi from '../optimus/api';
import dataApi from '../data/api';
import Poll from './poll';
import Bucket from '../data/bucket';
import Item from '../marketplace/item';

const POLLS_REQUEST = 'POLLS_REQUEST',
	POLLS_ERROR = 'POLLS_ERROR',
	POLLS_SUCCESS = 'POLLS_SUCCESS',
	POLLS_REQUEST_GET_INSTALLED = 'POLLS_REQUEST_GET_INSTALLED',
	POLLS_REQUEST_GET_INSTALLED_SUCCESS = 'POLLS_REQUEST_GET_INSTALLED_SUCCESS',
	POLLS_REQUEST_GET_INSTALLED_ERROR = 'POLLS_REQUEST_GET_INSTALLED_ERROR',
	POLLS_REQUEST_DELETE = 'POLLS_REQUEST_DELETE',
	POLLS_REQUEST_DELETE_SUCCESS = 'POLLS_REQUEST_DELETE_SUCCESS',
	POLLS_REQUEST_DELETE_ERROR = 'POLLS_REQUEST_DELETE_ERROR',
	POLLS_REQUEST_UPDATE_STATE = 'POLLS_REQUEST_UPDATE_STATE',
	POLLS_REQUEST_UPDATE_STATE_SUCCESS = 'POLLS_REQUEST_UPDATE_STATE_SUCCESS',
	POLLS_REQUEST_UPDATE_STATE_ERROR = 'POLLS_REQUEST_UPDATE_STATE_ERROR',
	POLL_DETAILS_REQUEST = 'POLL_DETAILS_REQUEST',
	POLL_DETAILS_REQUEST_SUCCESS = 'POLL_DETAILS_REQUEST_SUCCESS',
	POLL_DETAILS_REQUEST_ERROR = 'POLL_DETAILS_REQUEST_ERROR',
	POLL_LOGS_REQUEST = 'POLL_LOGS_REQUEST',
	POLL_LOGS_REQUEST_SUCCESS = 'POLL_LOGS_REQUEST_SUCCESS',
	POLL_LOGS_REQUEST_ERROR = 'POLL_LOGS_REQUEST_ERROR',
	CREATE_POLL = 'CREATE_POLL',
	POLL_UPDATE_REQUEST = 'POLL_UPDATE_REQUEST',
	POLL_UPDATE_REQUEST_SUCCESS = 'POLL_UPDATE_REQUEST_SUCCESS',
	POLL_UPDATE_REQUEST_ERROR = 'POLL_UPDATE_REQUEST_ERROR',
	SET_POLL_UPDATE_REQUEST_ERROR = 'SET_POLL_UPDATE_REQUEST_ERROR',
	POLL_UPDATE_RESET = 'POLL_UPDATE_RESET',
	POLLS_REQUEST_UPDATE_PENDING = 'POLLS_REQUEST_UPDATE_PENDING';


const state = {
	status: {},
	newPoll: {},
	createPollStatus: {},
	polls: [],
	installedPollsStatus: {},
	installedPolls: [],
	deleteStatus: {},
	updateStateStatus: {},
	selectedPoll: null,
	selectedPollStatus: {},
	pollLogs: null,
	pollLogsStatus: {},
	pollUpdateStatus: {}
};

const getters = {
	polls: state => state.polls,
	newPoll: state => state.newPoll,
	createPollStatus: state => state.createPollStatus,
	installedPolls: state => state.installedPolls,
	installedPollsStatus: state => state.installedPollsStatus,
	deleteStatus: state => state.deleteStatus,
	updateStateStatus: state => state.updateStateStatus,
	selectedPoll: state => state.selectedPoll,
	selectedPollStatus: state => state.selectedPollStatus,
	pollLogs: state => state.pollLogs,
	pollLogsStatus: state => state.pollLogsStatus,
	pollUpdateStatus: state => state.pollUpdateStatus
};

const actions = {
	[POLLS_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(POLLS_REQUEST);
		optimusApi.listPolls()
		.then(response => {
			let polls = response.data.map(Poll.fromDTO);

			commit(POLLS_SUCCESS, polls);
		})
		.catch(error => {
			commit(POLLS_ERROR);
		});
	},
	[CREATE_POLL]: ({ commit, dispatch, rootGetters }, payload) => {
		// TODO:
	},
	[POLLS_REQUEST_GET_INSTALLED]: ({ commit, dispatch, rootGetters }, payload = {}) => {
		commit(POLLS_REQUEST_GET_INSTALLED);
		let polls = null;
		optimusApi.listPolls({ installedOnly: true, withMarketItem: true })
		.then(response => {
			polls = response.data.filter(poll => poll.state !== 'ARCHIVED').map(Poll.fromDTO);
			if (payload.matchBuckets) {
				return dataApi.listBuckets();
			}
		})
		.then(response => {
			if (response) {
				let buckets = response.data.map(Bucket.fromDTO);
				polls.forEach(poll => {
					let matchedBucket = buckets.find(b => {
						return b.accessKey === poll.accessKey && b.bucketKey === poll.bucketKey;
					});
					if (matchedBucket) {
						poll.iotBucketId = matchedBucket.id;
						poll.iotBucketName = matchedBucket.name;
					}
				});
			}
			commit(POLLS_REQUEST_GET_INSTALLED_SUCCESS, polls);
		})
		.catch(error => {
			console.log(error);
			commit(POLLS_REQUEST_GET_INSTALLED_ERROR);
		});
	},
	[POLLS_REQUEST_DELETE]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(POLLS_REQUEST_DELETE);
		optimusApi.deletePoll({ pollId: payload.pollId })
		.then(response => {
			commit(POLLS_REQUEST_DELETE_SUCCESS, payload.pollId);
			dispatch('GET_STATS_REQUEST', { credits: true});
		})
		.catch(error => {
			console.log(error);
			commit(POLLS_REQUEST_DELETE_ERROR);
		});
	},
	[POLLS_REQUEST_UPDATE_STATE]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(POLLS_REQUEST_UPDATE_PENDING, payload.pollId);
		optimusApi.updatePollState({ pollId: payload.pollId, state: payload.state})
		.then(response => {
			commit(POLLS_REQUEST_UPDATE_STATE_SUCCESS, payload);
			dispatch('GET_STATS_REQUEST', { credits: true});
		})
		.catch(error => {
			console.log(error);
			commit(POLLS_REQUEST_UPDATE_STATE_ERROR);
		});
	},
	[POLL_DETAILS_REQUEST]: ({ commit, dispatch, rootGetters }, payload = {}) => {
		let poll = null;
		commit(POLL_DETAILS_REQUEST);
		optimusApi.getPollDetails({ pollId: payload.pollId })
		.then(response => {
			poll = Poll.fromDTO(response);

			if (payload.withMarketItem && poll && poll.from && poll.from.marketItemId) {
				return optimusApi.getItem({ itemId: poll.from.marketItemId });
			}
		})
		.then(response => {
			if (response) {
				poll.marketItem = Item.fromDTO(response.item);
			}
			commit(POLL_DETAILS_REQUEST_SUCCESS, poll);
		})
		.catch(error => {
			console.log(error);
			commit(POLL_DETAILS_REQUEST_ERROR);
		});
	},
	// logs
	[POLL_LOGS_REQUEST]: ({ commit, dispatch, rootGetters }, payload) => {
		let PREVIEW_LENGTH = 100;
		commit(POLL_LOGS_REQUEST);
		optimusApi.getPollLogs({ pollId: payload.pollId })
		.then(response => {
			let logs = response.items.map(l => {
				let data = JSON.stringify(l.data);
				let preview;
				if (data && data.length > PREVIEW_LENGTH) {
					preview = data.slice(0, PREVIEW_LENGTH) + '...';
				} else {
					preview = data;
				}
				l.dataPreview = preview;
				return l;
			});
			commit(POLL_LOGS_REQUEST_SUCCESS, logs);
		})
		.catch(error => {
			console.log(error);
			commit(POLL_LOGS_REQUEST_ERROR);
		});
	},
	// poll update
	[POLL_UPDATE_REQUEST]: ({ commit, dispatch, rootGetters }, payload = {}) => {
		let updatedPoll = null;
		commit(POLL_UPDATE_REQUEST);
		return optimusApi.updatePoll({ pollId: payload.pollId, payload })
		.then(response => {
			updatedPoll = Poll.fromDTO(response);
			if (payload.withMarketItem && updatedPoll && updatedPoll.from && updatedPoll.from.marketItemId) {
				return optimusApi.getItem({ itemId: updatedPoll.from.marketItemId });
			}
		})
		.then(response => {
			if (response) {
				updatedPoll.marketItem = Item.fromDTO(response.item);
			}
			commit(POLL_UPDATE_REQUEST_SUCCESS, updatedPoll);
			dispatch('GET_STATS_REQUEST', { credits: true});
		})
		.catch(error => {
			console.log(error);
			commit(POLL_UPDATE_REQUEST_ERROR);
		});
	},
	[POLL_UPDATE_RESET]: ({ commit, dispatch, rootGetters }, payload) => {
		commit(POLL_UPDATE_RESET);
	},
	[SET_POLL_UPDATE_REQUEST_ERROR]: ({ commit, dispatch, rootGetters }, msg) => {
		commit(POLL_UPDATE_REQUEST_ERROR, msg);
	},
};

const mutations = {
	// get polls
	[POLLS_REQUEST]: (state) => {
		state.status = {
			loading: true
		};
	},
	[POLLS_SUCCESS]: (state, polls) => {
		state.status = {
			success: true
		};
		Vue.set(state, 'polls', polls);
	},
	[POLLS_ERROR]: (state) => {
		state.status = {
			error: true
		};
	},
    // get installed polls
	[POLLS_REQUEST_GET_INSTALLED]: (state) => {
		state.installedPollsStatus = {
			loading: true
		};
	},
	[POLLS_REQUEST_GET_INSTALLED_SUCCESS]: (state, polls) => {
		state.installedPollsStatus = {
			success: true
		};
		state.installedPolls = polls;
	},
	[POLLS_REQUEST_GET_INSTALLED_ERROR]: (state) => {
		state.installedPollsStatus = {
			error: true
		};
	},
	// delete poll
	[POLLS_REQUEST_DELETE]: (state) => {
		state.deleteStatus = {
			loading: true
		};
	},
	[POLLS_REQUEST_DELETE_SUCCESS]: (state, deletedPollId) => {
		Vue.set(state, 'installedPolls', state.installedPolls.filter(poll => poll.id !== deletedPollId));
		state.deleteStatus = {
			success: true,
			loading: false
		};
	},
	[POLLS_REQUEST_DELETE_ERROR]: (state) => {
		state.deleteStatus = {
			loading: false,
			error: true
		};
	},
	[POLLS_REQUEST_UPDATE_PENDING]: (state, updatedPollId) => {
		let updatedPollIndex = state.installedPolls.findIndex(p => p.id === updatedPollId);
		if (updatedPollIndex >= 0) {
			Vue.set(state.installedPolls[updatedPollIndex], 'processing', true);
		}
	},
	[POLLS_REQUEST_UPDATE_STATE_SUCCESS]: (state, payload) => {
		let updatedPollId = payload.pollId;
		let newState = payload.state;
		let updatedPollIndex = state.installedPolls.findIndex(p => p.id === updatedPollId);
		if (updatedPollIndex >= 0) {
			Vue.set(state.installedPolls[updatedPollIndex], 'state', newState);
			Vue.set(state.installedPolls[updatedPollIndex], 'processing', false);
		}
		state.updateStateStatus = {
			success: true,
			loading: false
		};
	},
	// poll details
	[POLL_DETAILS_REQUEST]: (state) => {
		state.pollUpdateStatus = {};
		state.selectedPollStatus = {
			loading: true,
			success: null,
			error: null
		};
	},
	[POLL_DETAILS_REQUEST_SUCCESS]: (state, poll) => {
		state.selectedPoll = poll;
		state.selectedPollStatus = {
			loading: false,
			success: true
		};
	},
	[POLL_DETAILS_REQUEST_ERROR]: (state) => {
		state.selectedPollStatus = {
			loading: false,
			error: true
		};
	},
	// poll logs
	[POLL_LOGS_REQUEST]: (state) => {
		state.pollLogsStatus = {
			loading: true
		};
	},
	[POLL_LOGS_REQUEST_SUCCESS]: (state, logs) => {
		state.pollLogsStatus = {
			loading: false,
			success: true
		};
		state.pollLogs = logs;
	},
	[POLL_LOGS_REQUEST_ERROR]: (state) => {
		state.pollLogsStatus = {
			loading: false,
			error: true
		};
	},
	// poll update
	[POLL_UPDATE_REQUEST]: (state) => {
		state.pollUpdateStatus = {
			loading: true
		};
	},
	[POLL_UPDATE_REQUEST_SUCCESS]: (state, updatedPoll) => {
		state.pollUpdateStatus = {
			loading: false,
			success: true
		};
		state.selectedPoll = updatedPoll;
	},
	[POLL_UPDATE_REQUEST_ERROR]: (state, msg = null) => {
		state.pollUpdateStatus = {
			loading: false,
			error: true,
			errorMessage: msg
		};
	},
	[POLL_UPDATE_RESET]: (state) => {
		state.pollUpdateStatus = {
			loading: false,
			error: false,
			success: false
		};
	}
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/modules/polls/store.js